/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
  TableSelectRow,
  TableToolbar,
  TableBatchActions,
  TableBatchAction,
  Loading,
  TableSelectAll,
  FormGroup,
  FormLabel,
  Button,
  TextInput,
  Pagination,
  Tag,
} from 'carbon-components-react';
import PropTypes from 'prop-types';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Error16 from '@carbon/icons-react/lib/error/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Task16 from '@carbon/icons-react/lib/task/16';
import Report16 from '@carbon/icons-react/lib/report/16';
import ExportDoc16 from '@carbon/icons-react/lib/document--export/16';
import CheckmarkOutline16 from '@carbon/icons-react/lib/checkmark--outline/16';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom';
import { api, me } from '../../../helpers/api/api';
import { WFActionModal } from '../../common/WFActionModal';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import { CanExecuteAction, IsInRole } from '../../../helpers/authorization/Policies';
import { AppContext } from '../../../helpers/context/AppContext';
import {
  getError,
  STATUS,
  getSuccess,
  apioperation,
  entitiesLabels,
} from '../../../helpers/Constants';
import { NoRecordsPlaceholder } from '../../../helpers/jsonschemaform/DataTableExtention';
import { StatusTag } from '../../../helpers/PageBreadCrumb';
import Combo from '../../common/Combo';
import { Online, Offline } from '../../common/OnLineOffLine';
export default class EDrillMultiSelectDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      isLoadingNotificationFile: false,
      filteredEDrills: props.allYearEDrills,
      showFilters: false,
      filteredMonth: null,
      itemToDelete: [],
      itemToSubmit: [],
      selectedApprover: {},
      modalDeleteVisible: false,
      modalSubmitVisible: false,
      isSubmitted: false,
    };

    this.onSelectEDrillTypeChange = this.onSelectEDrillTypeChange.bind(this);
    this.onSelectStatusChange = this.onSelectStatusChange.bind(this);
    this.onSelectWorkSiteChange = this.onSelectWorkSiteChange.bind(this);
    this.onSelectTargetChange = this.onSelectTargetChange.bind(this);
    this.onSelectScopeChange = this.onSelectScopeChange.bind(this);
    this.onSelectDataApproverChange = this.onSelectDataApproverChange.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
    this.handleClickSearch = this.handleClickSearch.bind(this);
    this.validator = new SimpleReactValidator();
    this.handleChangePaging = this.handleChangePaging.bind(this);

    this.filters = {};
    this.textInput = React.createRef();
    this.toogleFilterModal = this.toogleFilterModal.bind(this);

    this.validations = {
      dataApprover: this.validator.message(
        'dataApprover',
        this.state.selectedApprover.id,
        'required'
      ),
    };
  }

  DownloadEDrillNotification(drillReportId) {
    this.setState({ isLoadingNotificationFile: true });
    api
      .getWithParam('/drill/' + drillReportId + '/export', {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        var data = new Blob([response.data], { type: 'application/pdf' });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        const eDrillCode = this.props.eDrills.find((i) => i.id == drillReportId);
        var nomefile = 'Drill_Notification_' + eDrillCode.drillReportCode + '.pdf';
        tempLink.setAttribute('download', nomefile);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_NOTIFICATION, apioperation.DOWNLOAD));
        //console.log(eDrillId);
      })
      .finally(() => {
        this.setState({ isLoadingNotificationFile: false });
      });
  }
  DownloadEDrillReport(eDrillId) {
    this.setState({ isLoadingNotificationFile: true });
    api
      .getWithParam('/drill/' + eDrillId + '/exportreport', {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        var data = new Blob([response.data], { type: 'application/zip' });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        const eDrillCode = this.props.eDrills.find((i) => i.id == eDrillId);
        var nomefile = 'Drill_Report_' + eDrillCode.drillReportCode + '.zip';
        tempLink.setAttribute('download', nomefile);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_NOTIFICATION, apioperation.DOWNLOAD)
        );
        //console.log(eDrillId);
      })
      .finally(() => {
        this.setState({ isLoadingNotificationFile: false });
      });
  }

  static getDerivedStateFromProps(props, state) {
    // Any time the current user changes,
    // Reset any parts of state that are tied to that user.
    // In this simple example, that's just the email.
    if (props.allYearEDrills !== state.filteredEDrills) {
      return {
        filteredEDrills: props.allYearEDrills,
      };
    }
    return null;
  }

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  renderDeleteModal = (totalItems) =>
    this.state.modalDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading"> Delete draft Drills</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteClose}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row" />
            <div className="bx--col-lg-12 bx--col-md-12">
              <h4 className="align-center">
                Press confirm to delete
                {` ${totalItems} `}
                Drill/s selected
              </h4>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button className="button--max-width" kind="secondary" onClick={this.handleDeleteClose}>
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.handleDeleteSubmit}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderSubmitModal = (totalItems) => {
    const validations = {
      dataApprover: this.validator.message(
        'dataApprover',
        this.state.selectedApprover.id,
        'required'
      ),
    };
    return (
      this.state.modalSubmitVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Submit Drill</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handleStatusSubmitClose}
              />
            </div>

            <div className="bx--modal-content bx-modal-content-detail">
              <div className="bx--row" />
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">
                  Choose a Data Approver and than confirm to submit
                  {` ${totalItems} `}
                  Drill/s selected
                </h5>
              </div>
              <div className="bx--row" />
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handleStatusSubmitClose}
              >
                Cancel
              </Button>
              <Button
                className="button--max-width"
                kind="primary"
                onClick={this.handleStatusSubmit}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  toogleCalendar = (e) => {
    this.props.toogleCalendar(e);
  };

  toogleFilterModal = (e) => {
    this.props.toogleFilterModal(e);
  };

  handleChangePaging = (event) => {
    this.props.handleChangePaging(event);
  };

  onSelectEDrillTypeChange = (selectedItem) => {
    this.props.onTypeFilter(selectedItem);
  };

  onSelectScopeChange = (selectedItem) => {
    this.props.onScopeFilter(selectedItem);
  };

  onSelectTargetChange = (selectedItem) => {
    this.props.onTargetFilter(selectedItem);
  };

  onSelectStatusChange = (selectedItem) => {
    this.props.onStatusFilter(selectedItem);
  };

  onSelectWorkSiteChange = (selectedItem) => {
    this.props.onWorkSiteFilter(selectedItem);
  };

  onSelectDataApproverChange = (selectedItem) => {
    this.setState({
      selectedApprover: selectedItem || {},
    });
  };

  buildNoMonthFilter = () => {
    let { filteredEDrills } = this.state;
    filteredEDrills = this.state.filteredDivision
      ? filteredEDrills.filter((item) => item.idDivision === this.state.filteredDivision)
      : filteredEDrills;
    return filteredEDrills;
  };

  onMonthFilter = (event) => {
    this.setState({
      filteredMonth: event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null,
      filteredEDrills: this.buildNoMonthFilter(),
    });
    this.props.onMonthFilter(
      event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null
    );
  };

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;
    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/drill/${apiEndpoint}`, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            // isLoading: true,
            // itemList: []
          });
          this.props.onRefreshData();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, error.response.data, 'ERROR'));
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
    me.getWithParam('getuserbyroleandmodule', { //RITM1064131
      params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, '', 'ERROR'));
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  // eslint-disable-next-line react/sort-comp
  IsRowSelectable(tableRow, selectedRows, user) {
    const entity = this.props.eDrills.find((i) => i.id == tableRow.id);
    if (entity.idStatus === 4) return false;
    if (entity.idStatus === 1 && entity.compiler == null) return true;

    const canSelect =
      CanExecuteAction(
        'Emergency Drill',
        'Reporting',
        user,
        entity.idStatus,
        'Create',
        this.getEDrillor(entity)
      ) ||
      CanExecuteAction('Emergency Drill', 'Reporting', user, entity.idStatus, 'Submit', entity) ||
      CanExecuteAction('Emergency Drill', 'Reporting', user, entity.idStatus, 'Approve', entity) ||
      CanExecuteAction(
        'Emergency Drill',
        'Reporting',
        user,
        entity.idStatus,
        'Consolidate',
        entity
      ) ||
      CanExecuteAction('Emergency Drill', 'Reporting', user, entity.idStatus, 'Reject', entity) ||
      CanExecuteAction(
        'Emergency Drill',
        'Reporting',
        user,
        entity.idStatus,
        'RejectConsolidate',
        entity
      );

    if (selectedRows.length == 0) {
      return canSelect;
    }

    if (selectedRows.length > 0) {
      const selectableEDrill = this.props.eDrills.find((i) => i.id == selectedRows[0].id);
      const selectableState = selectableEDrill.idStatus;
      const selectableDivision = selectableEDrill.idDivision;
      const selectableWorksite = selectableEDrill.idWorksite;

      if (
        entity.idStatus == selectableState &&
        (entity.idStatus == 1
          ? entity.idWorkSite == selectableWorksite
          : entity.idDivision == selectableDivision)
      ) {
        return canSelect;
      }

      return false;
    }

    return false;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    const eDrill = this.props.eDrills.find((i) => i.id === selectedRows[0].id);

    const idWorksite = eDrill.idWorkSite; //RITM1064131
		const idDivision = eDrill.workSite?.idDivision; //RITM1064131

    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover,
      selectedData: selectedRows,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
    });

    if (withApprover) this.getUsersInRole(approverRole, 'Emergency Drill', idWorksite, idDivision); //RITM1064131
  }
  /** ***********Render******************* */

  getEDrillor = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      let au = this.props.eDrills.find((el) => el.id == selectedRows[0].id);
      return au && au.eDrillors && au.eDrillors[0] ? { idCompiler: au.eDrillors[0].id } : null;
    }
    return null;
  };


  //RITM0723662
  getCompiler = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      let au = this.props.eDrills.find((el) => el.id == selectedRows[0].id);
      return au && au.compiler ? { idCompiler: au.idCompiler } : null;
    }
    return null;
  };

  getCompilerById = (idRow) => {
    if (idRow) {
      let au = this.props.eDrills.find((el) => el.id == idRow);
      return au && au.compiler ? { idCompiler: au.idCompiler } : null;
    }
    return null;
  };
  //RITM0723662

  getEDrillReport = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      const r = this.props.eDrills.find((el) => el.id == selectedRows[0].id);
      return r;
    }
    return null;
  };

  getReportStatusId = (idRow) => {
    const r = this.props.eDrills.find((el) => el.id == idRow);
    return r && r.idStatus;
  };

  renderMonthsHeader = () => {
    const elements = [
      'All',
      'Gen',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const items = elements.map((item, index) => (
      // eslint-disable-next-line jsx-a11y/interactive-supports-focus
      <div
        focusable="true"
        onClick={this.onMonthFilter}
        className={` bx--col bx--header-orientation header-calendar row-description-calendar  ${
          (!this.state.filteredMonth && index === 0) || this.state.filteredMonth === index
            ? 'bx--header-orientation-current'
            : ''
        }`}
        id={index}
        key={`monthHead-${item}`}
        role="button"
      >
        <div className="detail">{item}</div>

        <div className="information-number number">
          {index > 0
            ? this.state.filteredEDrills.filter((elem) => elem.referenceMonth === index).length
            : this.state.filteredEDrills.length}
        </div>
      </div>
    ));

    return <div className="bx--row description-header ">{items}</div>;
  };

  getCellValue = (type, value, id) => {
    if (!value) return '';

    const drill = this.props.eDrills.find((el) => el.id == id);

    if (type.header.includes('deliveryDateWithWeek')) {
      if (drill.isInPlannedWeek) {
        return (
          <Tag className="auditTag" type="green" disabled={false} role="listitem">
            {value}
          </Tag>
        );
      } else {
        return (
          <Tag className="auditTag" type="red" disabled={false} role="listitem">
            {value}
          </Tag>
        );
      }
    }

    //RITM0723662
    if (type.header.includes('compilerAssignStatus')) {
      if (!value) return ''
      else return value;
    }
    //RITM0723662 fine 
    
    if (typeof value === 'object') {
      let plannedweek = '';
      console.log(type, value, id);
      console.log(drill);

      if (type.header.includes('eDrillor')) {
        return value.fullName;
      }
      if (type.header.includes('status')) {
        return <StatusTag value={"drill"+value.reportingName} />;
      }

      if (value instanceof Array) {
        return value.map((elem) => elem.name).join(', ');
      }
      return value.name;
    }
    if (type.header.includes('Month')) {
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const monthToString = (monthNumber) => months[monthNumber - 1] || '';
      return monthToString(value);
    }
    return value;
  };

  handleClickCancelSearch = () => {
    this.textInput.current.value = '';
    for (var prop in this.filters) {
      if (Object.prototype.hasOwnProperty.call(this.filters, prop))
        this.filters[prop] = Array.isArray(this.filters[prop]) ? [] : null;
    }
    this.props.applyFilters(this.filters, false);
  };

  handleClickSearch = () => {
    this.props.applyFilters(this.filters, true);
  };

  showFilters() {
    this.setState((oldState) => ({ showFilters: !oldState.showFilters }));
    this.toogleFilterModal();
  }

  renderFilters = () => (
    <div style={{ display: this.state.showFilters ? 'block' : 'none' }}>
      <div className="bx--row">
        <FormGroup className="bx--col-lg-6 bx--col-md-4">
          <FormLabel>Company</FormLabel>
          <Combo
            url="me/companies"
            onChange={(event) => (this.filters['company'] = event.selectedItem)}
            onError={(error) => {}}
            disabled={false}
            initialSelectedItems={this.filters['company']}
          />
        </FormGroup>

        <FormGroup className="bx--col-lg-6 bx--col-md-4">
          <FormLabel>Worksite</FormLabel>
          <Combo
            url="me/workSites"
            onChange={(event) => (this.filters['workSite'] = event.selectedItem)}
            onError={(error) => {}}
            disabled={false}
            initialSelectedItems={this.filters['workSite']}
          />
        </FormGroup>

        <FormGroup className="bx--col-lg-4 bx--col-md-4">
          <FormLabel>Drill Code</FormLabel>
          <TextInput
            id="drillCode"
            name="drillCode"
            onChange={(event) => (this.filters['drillCode'] = event.target.value)}
            type="text"
            ref={this.textInput}
          />
        </FormGroup>

        {/*<FormGroup className="bx--col-lg-6 bx--col-md-4">
                    <FormLabel>Projects</FormLabel>
                  <Combo
                      multiCombo={true}
                      url="me/project"
                      onChange={prjs =>
                          this.filters['projects'] = prjs
                      }
                      onError={(error) => { }}
                      initialSelectedItems={this.filters['projects'] || []}
                      disabled={false}
                  />
                </FormGroup> */}

        <FormGroup className="bx--col-lg-4 bx--col-md-4">
          <FormLabel>Drill Type</FormLabel>
          <Combo
            url="drill/drilltype"
            onChange={(event) => (this.filters['drillType'] = event.selectedItem)}
            onError={(error) => {}}
            loadAll
            disabled={false}
            initialSelectedItems={this.filters['drillType']}
          />
        </FormGroup>

        <FormGroup className="bx--col-lg-4 bx--col-md-4">
          <FormLabel>Drill Type Detail</FormLabel>
          <Combo
            url="drill/drilltype/drilltypedetails"
            onChange={(event) => (this.filters['drillTypeDetail'] = event.selectedItem)}
            onError={(error) => {}}
            loadAll
            disabled={false}
            initialSelectedItems={this.filters['drillTypeDetail']}
          />
        </FormGroup>
      </div>

      <div className="searchFormFooter">
        <Button
          className="button--max-width"
          size="small"
          kind="secondary"
          onClick={this.handleClickCancelSearch}
        >
          Cancel
        </Button>
        <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
          Search
        </Button>
      </div>
    </div>
  );

  render() {
    const headers = [
      {
        key: 'drillReportCode',
        header: 'Drill Report Code',
      },
      {
        key: 'drillEmergencyLevel',
        header: 'Emergency Level',
      },
      {
        key: 'plannedWeekWithDate',
        header: 'Planned Week',
      },
      {
        key: 'deliveryDateWithWeek',
        header: 'Effective Date',
      },
      {
        key: 'status',
        header: 'Status',
      },
      {
        key: 'compilerAssignStatus',
        header: 'Compiler Assign Status',
      },
    ];
    const paginationProps = () => ({
      page: this.props.paginationInfo.currentPage || 1,
      totalItems: this.props.paginationInfo.rowCount || 0,
      pageSize: this.props.paginationInfo.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });

    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <Loading active={this.state.isLoadingNotificationFile} withOverlay={true} />
            <DataTable
              useZebraStyles="true"
              rows={this.props.eDrills}
              headers={headers}
              render={({
                rows,
                getHeaderProps,
                getSelectionProps,
                getBatchActionProps,
                selectedRows,
              }) => (
                <TableContainer>
                  {selectedRows.length > 0 ? (
                    <TableToolbar>
                      <Online>
                        <TableBatchActions {...getBatchActionProps()}>
                          {selectedRows.length > 0 ? (
                            <>
                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                (selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null) || '',
                                'Create',
                                this.getEDrillor(selectedRows) //caso particolare, questa azione la può fare l'eDrillor indicato nel plan
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Task16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'newreport',
                                      'Assign',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Assign Report
                                </TableBatchAction>
                              ) : null}

                                  
                               {this.getReportStatusId(selectedRows[0].id) == 1 //RITM0723662 
                               && !this.getCompiler(selectedRows) && 
                               (IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) ? ( //RITM1064131
                                <TableBatchAction
                                  renderIcon={Task16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'updatereportcompiler',
                                      'Assign',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Assign Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null,
                                'Submit',
                                this.getEDrillReport(selectedRows)
                              ) &&  this.getCompiler(selectedRows) ? (
                                <TableBatchAction
                                  renderIcon={Send16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'submitreport',
                                      'Submit',
                                      'Data Approver',
                                      true,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Submit Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null,
                                'Approve',
                                this.getEDrillReport(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'approvereport',
                                      'Approve',
                                        null, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                                        false, /*RUOLI_APPROVATIVI_DEV_255_RITM0565449*/
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Approve Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null,
                                'Consolidate',
                                this.getEDrillReport(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'consolidatereport',
                                      'Consolidate',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Consolidate Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null,
                                'Reject',
                                this.getEDrillReport(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Error16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'rejectreport',
                                      'Reject',
                                      null,
                                      false,
                                      true,
                                      selectedRows
                                    )
                                  }
                                >
                                  Reject Report
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Emergency Drill',
                                'Reporting',
                                user,
                                selectedRows.length > 0
                                  ? this.getReportStatusId(selectedRows[0].id)
                                  : null,
                                'RejectConsolidate',
                                this.getEDrillReport(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Error16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'rejectconsolidatereport',
                                      'Reject',
                                      null,
                                      false,
                                      true,
                                      selectedRows
                                    )
                                  }
                                >
                                  Reject Report
                                </TableBatchAction>
                              ) : null}
                            </>
                          ) : null}
                        </TableBatchActions>
                      </Online>
                    </TableToolbar>
                  ) : (
                    ''
                  )}

                  {this.renderFilters()}

                  <WFActionModal
                    show={this.state.isApprovalModalOpen}
                    title={`${this.state.approvalModalAction} Drills`}
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseApprovalModal}
                    onConfirm={this.handleConfirmApprovalModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                    user={user} //RITM1064131
                  />

                  <Table>
                    <TableHead>
                      <TableRow>
                        <Online><TableSelectAll {...getSelectionProps()} /></Online>
                        <Offline><TableSelectAll {...getSelectionProps()} disabled /></Offline>
                        {headers.map((header) => (
                          <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                        ))}
                        <TableHeader className="align-center">Actions</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length == 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 2} />
                      ) : (
                        rows.map((row) => (
                          <TableRow key={row.id}>
                            <Online>
                              {this.IsRowSelectable(row, selectedRows, user) ? (
                                <TableSelectRow {...getSelectionProps({ row })} />
                              ) : (
                                <TableCell
                                  key={`empty${row.id}`}
                                  className="tableActions align-center"
                                />
                              )}
                            </Online>
                            <Offline>
                              <TableSelectRow {...getSelectionProps({ row })} disabled />
                            </Offline>
                            {row.cells.map((cell) => (
                              <TableCell key={cell.id}>
                                {this.getCellValue(cell.info, cell.value, row.id)}
                              </TableCell>
                            ))}
                            <TableCell
                              key={`action-${row.id}`}
                              className="tableActions align-center"
                            >
                              <div>
                                <Online>
                                  {this.getReportStatusId(row.id) && (
                                    <Button
                                      size="small"
                                      className="bx--export-form"
                                      renderIcon={ExportDoc16}
                                      iconDescription="Download Notification"
                                      title="Download Notification"
                                      kind="ghost"
                                      onClick={() => this.DownloadEDrillNotification(row.id)}
                                    />
                                  )}
                                  {this.getReportStatusId(row.id) && (
                                    <Button
                                      size="small"
                                      className=" bx--export-tab-form"
                                      renderIcon={ExportDoc16}
                                      iconDescription="Download Report"
                                      title="Download Report"
                                      kind="ghost"
                                      onClick={() => this.DownloadEDrillReport(row.id)}
                                    />
                                  )}
                                </Online>
                                {this.getReportStatusId(row.id) && 
                                 this.getCompilerById(row.id) && 
                                  (
                                  <Link to={`/drill/report/${row.id}`}>
                                    <Button
                                      size="small"
                                      renderIcon={Report16}
                                      title="View Drill Report Details"
                                      iconDescription="View Drill Report Details"
                                      kind="ghost"
                                    />
                                  </Link>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />

            <div className="footer-pagination">
              <Pagination {...paginationProps()} />
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}

EDrillMultiSelectDataTable.propTypes = {
  eDrills: PropTypes.array.isRequired,
  // onNewEDrill: PropTypes.func.isRequired,
  onEditEDrill: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
